<template>
  <div id="content"
       class="container">
    <header class="m15">
      <div class="integralBreadcrumb">
        <div class="integralBreadcrumb-item" style="min-width: 30px"
             @click="routerHandle('onlineTraining')">首页</div>
        <div class="el-icon-arrow-right jt"></div>
        <div class="integralBreadcrumb-item" style="min-width: 60px"
             @click="routerHandle('trainTrend')">工控动态</div>
        <div class="el-icon-arrow-right jt"></div>
        <div class="integralBreadcrumb-item ellipsis">{{dataForm.title}}</div>
      </div>
    </header>
    <div class="all-left-wrap"
         style="padding:20px;padding-top:0px">
      <div class="left-title">
        <h2>{{dataForm.title}}</h2>
        <div class="left-action">
          <div class="left-time">{{dataForm.createTime}}</div>
          <div class="left-do">
            <div class="train-comment">
              <img style="float:left;"
                   title="评论"
                   src="../../../../assets/img/comment_03.png" />
              <span style="float:left;margin-left:5px">{{dataForm.commentCount}}</span>
            </div>
            <div class="train-praise">
              <img style="float:left;"
                   title="赞一下"
                   src="../../../../assets/img/zan_03.png" />
              <span style="float:left;margin-left:5px"
                    @click="handleZan(dataForm.id,3)">{{dataForm.praiseCount}}</span>
            </div>
          </div>
        </div>
      </div>
      <!-- 内容区 -->
      <div class="left-content">
        <div class="train-p"
             v-html="decodeURIComponent(dataForm.content)">
        </div>
        <div class="content-share">
          <div class="read">
            <span>阅读数:</span>
            {{dataForm.clickNum}}
          </div>
          <div class="wechat">
            <span>
              <img src="../../../../assets/img/wechat_03.png" />
            </span>
            <span class="zan"
                  title="赞一下"
                  @click="handleZan(dataForm.id,3)">
              <img src="../../../../assets/img/zan_03.png" />
              {{dataForm.praiseCount}}
            </span>
          </div>
        </div>
      </div>
      <!-- 评论区 -->
      <!-- 输入评论区域 -->
      <div class="comment">
        <div class="comment-input">
          <div class="comment-ava">
            <img :src="imgUrl" />
          </div>
          <div class="comment-right">
            <div class="comment-cont">
              <el-input type="textarea"
                        placeholder="请输入您要回复的文字(最多500字).."
                        maxlength="500"
                        v-model="dataForm.myreply"></el-input>
            </div>
            <div class="comment-me">
              <el-button style="width:130px;height:34px;background:#fff;border:1px solid #1D65A8;color:#1D65A8"
                         @click="handleComment('')">我来评价</el-button>
            </div>
          </div>
        </div>
      </div>
      <!-- 评论列表 -->
      <div class="comment-list">
        <ul>
          <li v-for="(data,index) in dataForm.AnswerList"
              :key="data.id">
            <div class="comment-ava"
                 style="float:left">
              <img :src="data.userAvatarURL?data.userAvatarURL:imgUrl" />
            </div>
            <div class="comment-info">
              <p>{{data.userNickname}} 评论:</p>
              <p class="comment-info-con">{{data.content}}</p>
              <div>
                <div class="comment-time">发表于{{data.createTime}}</div>
                <div class="comment-right-con">
                  <div class="train-comment"
                       @click="handleClick(data.id,index)">
                    <img style="float:left;"
                         title="评论"
                         src="../../../../assets/img/comment_03.png" />
                    <span style="float:left;margin-left:5px">{{data.replyCount}}</span>
                  </div>
                  <div class="train-praise"
                       @click="handleZan(data.id,4)">
                    <img style="float:left;"
                         title="赞一下"
                         src="../../../../assets/img/zan_03.png" />
                    <span style="float:left;margin-left:5px">{{data.praiseCount}}</span>
                  </div>
                </div>
              </div>
              <!-- 点击评论展示评论框 -->
              <div class="comment-show"
                   v-show="data.showContent">
                <el-input type="textarea"
                          placeholder="请输入您要回复的文字"
                          style="margin-bottom:5px;"
                          v-model="dataForm.myCommentReply"></el-input>
                <el-button style="float:right;margin-left:5px;width:62px;height:30px;background:#fff;border:1px solid #1D65A8;color:#1D65A8;font-size:12px;"
                           @click="handleComment(data.id,index)">回复</el-button>
                <el-button style="float:right;width:62px;height:30px;background:#fff;border:1px solid #1D65A8;color:#1D65A8;font-size:12px;text-align:center"
                           @click="handleCancel(index)">取消</el-button>
              </div>
              <!-- 评论回复显示评论的回答 -->
              <div class="comment-all-reply"
                   v-show="data.showContent && data.commentVos.length">
                <ul>
                  <li v-for="item in data.commentVos"
                      :key="item.id">
                    <div class="comment-ava new-img">
                      <img :src="item.userAvatarURL?item.userAvatarURL:imgUrl" />
                    </div>
                    <div class="com-reply">
                      <p>{{item.userNickname}} 评论:</p>
                      <p class="com-cont color-666">{{item.content}}</p>
                      <p class="color-999">发表时间 {{item.createTime}}</p>
                    </div>
                    <div class="com-good"
                         title="赞一下"
                         @click="handleZan(item.id,4)">
                      <img style="float:left;margin-left:15px;"
                           src="../../../../assets/img/zan_03.png" />
                      <span style="float:left;margin-left:5px">{{item.praiseCount}}</span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <!-- 分页 -->
      <div class="doclist-pagination"
           v-if="dataForm.AnswerList === [] || dataForm.AnswerList.length !== 0">
        <div class="doclist-lastpage"
             @click="jumpLastPage">上一页</div>
        <div class="doclist-omit">{{lastOmit}}</div>
        <ul>
          <li :class="item === currentPage?'pageactive':''"
              v-for="(item, index) in pageList"
              :key="index"
              @click="getCommentList(item)">{{item}}</li>
        </ul>
        <div class="doclist-omit">{{nextOmit}}</div>
        <div class="doclist-nextpage"
             @click="jumpNextPage">下一页</div>
        <div class="doclist-pagejump">
          共{{totalPage}}页，到第
          <input type="text"
                 v-model.number="jumpTargetPage" />页
        </div>
        <div class="doclist-jump"
             @click="jumpFarPage">确定</div>
      </div>
    </div>
    <trainTrendRank :type="dataForm.articleType"
                    ref="trainTrendRank"></trainTrendRank>
  </div>
</template>
<script>
import trainTrendRank from './trainTrendRank'
export default {
  data () {
    return {
      dataForm: {
        id: '',
        title: '',
        commentCount: '',
        praiseCount: '',
        createTime: '',
        imageUrl: '',
        summary: '',
        clickNum: '',
        AnswerList: [],
        myreply: '',
        myCommentReply: '',
        commentId: null,
        subCommentList: [],
        articleType: ''
      },
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      totalData: 0,
      imgUrl: require('@/assets/img/avatar-boy.gif'),
      status: false,
      which: '',
      SubId: '',
      currentPage: 1,
      lastOmit: '',
      nextOmit: '...',
      pageList: [1, 2, 3, 4, 5],
      jumpTargetPage: 1
    }
  },
  components: {
    trainTrendRank
  },
  mounted () {
    this.getInfo(1)
    this.getCommentList()
  },
  watch: {
    $route (to, from) {
      if (this.$route.query.id) {
        this.getInfo(1)
        this.getCommentList()
      }
    }
  },
  methods: {
    routerHandle (routerName) {
      if (routerName === 'onlineTraining') {
        this.$router.push({ name: 'onlineTraining' })
      } else if (routerName === 'trainTrend') {
        let trainListQuery = sessionStorage.getItem('trainListQuery')
        this.$router.push({ name: 'trainTrendList', query: { ...JSON.parse(trainListQuery) } })
      }
    },
    saveRecord (key, desc) {
      // 埋点
      this.$http.post(`${window.SITE_CONFIG['apiURL']}/front/consumer/knowledgeTrainRecord/save`, {
        userId: this.$store.state.user.id || null,
        eventId: key,
        eventType: 'click',
        desc: desc,
        source: 'PC',
        stayTime: '',
        busId: this.$route.query.id || null
      })
    },
    // 获取详情数据
    getInfo (isFirst) {
      this.$http.post(`/front/train/trainNews/infoWithComment/${this.$route.query.id}`)
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.dataForm.id = res.data.id
            this.dataForm.title = res.data.title
            this.dataForm.commentCount = res.data.commentCount
            this.dataForm.createTime = res.data.createTime
            this.dataForm.imageUrl = res.data.imageUrl
            this.dataForm.summary = res.data.summary
            this.dataForm.clickNum = res.data.clickNum
            this.dataForm.praiseCount = res.data.praiseCount
            this.dataForm.content = res.data.content
            this.dataForm.articleType = res.data.articleType
            if (this.dataForm.articleType === '1') {
              this.$refs.trainTrendRank.getDataList()
              if (isFirst) {
                this.saveRecord('INDUSTRIAL_DYNAMICS_NEWS', '工业动态_新闻')
              }
            } else {
              this.$refs.trainTrendRank.getMerDataList()
              if (isFirst) {
                this.saveRecord('INDUSTRIAL_DYNAMICS_TRAINING_SOUVENIR', '工业动态_培训留念')
              }
            }
          }
        })
    },
    // 获取评论数据
    getCommentList (page = this.currentPage) {
      this.$http.post(`/front/train/trainComment/listNewsCommentsAtDetailPage`, {
        'page': page,
        'limit': this.pageSize,
        'id': this.$route.query.id
      }).then(({ data: res }) => {
        if (res.code === 0) {
          this.dataForm.AnswerList = res.data.data
          this.dataForm.AnswerList.forEach(item => {
            item.showContent = false
          })
          // 分页
          this.totalPage = Math.ceil(res.data.count / 10)
          this.changePageTo(page)
        }
        this.totalData = (res && res.data && res.data.count) || 0
        this.$nextTick(() => {
          this.$set(this.dataForm.AnswerList, this.which, { ...this.dataForm.AnswerList[this.which], showContent: true })
        })
      })
      this.jumpTargetPage = 1
    },
    // 我来评价
    handleComment (id, index) {
      this.which = index
      this.$http.post(`/front/train/trainComment/saveNewAndMemorialComment`,
        {
          'content': id === '' ? this.dataForm.myreply : this.dataForm.myCommentReply,
          'businessId': this.$route.query.id,
          'pCommentId': id
        }
      ).then(({ data: res }) => {
        if (res && res.code === 0) {
          this.$message({
            message: '操作成功',
            type: 'success',
            duration: 1500,
            onClose: () => {
              this.butLoading = false
              this.dataForm.myreply = ''
              this.dataForm.myCommentReply = ''
              this.getInfo()
              this.getCommentList()
            }
          })
        } else {
          this.$message.error(res.msg || '评论失败')
          this.butLoading = false
        }
      })
    },
    // 展示评论框
    handleClick (id, index) {
      var show = !this.dataForm.AnswerList[index].showContent
      this.$set(this.dataForm.AnswerList, index, { ...this.dataForm.AnswerList[index], showContent: show })
    },
    // 取消
    handleCancel (index) {
      this.$set(this.dataForm.AnswerList, index, { ...this.dataForm.AnswerList[index], showContent: false })
    },
    // 点赞
    handleZan (id, type) {
      this.$http.post(`/front/train/trainPraise/save`,
        {
          'targetId': id,
          'type': type
        })
        .then(data => {
          if (data.data.code === 0) {
            this.$message({
              message: '点赞成功',
              type: 'success',
              duration: 1500,
              onClose: () => {
                this.getInfo()
                this.getCommentList()
              }
            })
          } else {
            this.$message.error(data.data.msg)
          }
        })
    },
    // 分页
    jumpLastPage () {
      if (this.currentPage > 1) {
        var newCurrent = this.currentPage - 1
        this.getCommentList(newCurrent)
      } else {
        this.$message.info('这已经是第一页啦')
      }
    },
    jumpNextPage () {
      if (this.currentPage < this.totalPage) {
        var newCurrent = this.currentPage + 1
        this.getCommentList(newCurrent)
      } else {
        this.$message.info('这已经是最后一页啦')
      }
    },
    changePageTo (page) {
      window.scrollTo(0, 0)
      if (this.totalPage > 5) {
        if (page > 2 && page < this.totalPage - 1) {
          var newPageList = []
          for (let index = page - 2; index < page + 3; index++) {
            newPageList.push(index)
          }
          this.pageList = newPageList
          this.currentPage = page
          this.lastOmit = '...'
          this.nextOmit = '...'
        } else if (page <= 2) {
          this.pageList = [1, 2, 3, 4, 5]
          this.currentPage = page
          this.lastOmit = ''
          if (page >= this.totalPage - 2) {
            this.nextOmit = ''
          } else {
            this.nextOmit = '...'
          }
        } else {
          var newPageList2 = [
            this.totalPage - 4,
            this.totalPage - 3,
            this.totalPage - 2,
            this.totalPage - 1,
            this.totalPage
          ]
          this.pageList = newPageList2
          this.currentPage = page
          this.lastOmit = '...'
          this.nextOmit = ''
        }
      } else {
        var newPageList5 = []
        for (let index = 1; index <= this.totalPage; index++) {
          newPageList5.push(index)
        }
        this.pageList = newPageList5
        this.lastOmit = ''
        this.nextOmit = ''
        this.currentPage = page
      }
      // this.getInfo()
      // this.getCommentList();
    },
    jumpFarPage () {
      if (this.jumpTargetPage >= 1 && this.jumpTargetPage <= this.totalPage) {
        if (this.totalPage > 5) {
          if (
            this.jumpTargetPage > 2 && this.jumpTargetPage < this.totalPage - 4
          ) {
            var newPageList3 = []
            for (
              let index = this.jumpTargetPage - 2;
              index < this.jumpTargetPage + 3;
              index++
            ) {
              newPageList3.push(index)
            }
            this.pageList = newPageList3
            this.currentPage = this.jumpTargetPage
            this.lastOmit = '...'
            this.nextOmit = '...'
          } else if (this.jumpTargetPage <= 2) {
            this.pageList = [1, 2, 3, 4, 5]
            this.currentPage = this.jumpTargetPage
            this.lastOmit = ''
            if (this.jumpTargetPage > this.totalPage - 3) {
              this.nextOmit = ''
            } else {
              this.nextOmit = '...'
            }
          } else {
            var newPageList4 = [
              this.totalPage - 4,
              this.totalPage - 3,
              this.totalPage - 2,
              this.totalPage - 1,
              this.totalPage
            ]
            this.pageList = newPageList4
            this.currentPage = this.jumpTargetPage
            this.lastOmit = '...'
            this.nextOmit = ''
          }
        } else {
          var newPageList5 = []
          for (let index = 1; index <= this.totalPage; index++) {
            newPageList5.push(index)
          }
          this.pageList = newPageList5
          this.lastOmit = ''
          this.nextOmit = ''
          this.currentPage = this.jumpTargetPage
        }
        this.getInfo()
        this.getCommentList()
        window.scrollTo(0, 0)
      } else {
        this.$message.error('请输入正确的页码')
      }
    },
    // 每页数
    sizeChangeHandle (val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getInfo()
      this.getCommentList()
    },
    // 当前页
    currentChangeHandle (val) {
      this.pageIndex = val
      this.getInfo()
      this.getCommentList()
    },
    // 多选
    selectionChangeHandle (val) {
      this.dataListSelections = val
    }
  }
}
</script>
<style scoped>
.all-left-wrap {
  width: 870px;
  min-height: 1531px;
  float: left;
  background: #fff;
  margin-top: 10px;
  margin-bottom: 10px;
  padding: 0 20px;
}
.left-title {
  width: 830px;
  border-bottom: 1px solid #ccc;
  padding-top: 0px;
}
.left-title h2 {
  width: 830px;
  font-weight: 700;
  color: #333;
  font-size: 18px;
}
.left-action {
  width: 830px;
  height: 55px;
}
.left-time {
  float: left;
  width: 200px;
  height: 55px;
  line-height: 55px;
  color: #999;
}
.left-do {
  float: right;
  width: 120px;
  height: 55px;
}
.train-p >>> img {
  max-width: 100% !important;
}
.train-p >>> video {
  max-width: 100% !important;
}
.train-p >>> p {
  max-width: 100% !important;
}
.train-p >>> ul {
  max-width: 100% !important;
}
/* .train-p >>> p span strong img{
  width:15px !important
} */
/* .train-p img{
  width:100%;
} */
.train-praise {
  margin-left: 20px;
  height: 55px;
  width: 40px;
  float: left;
  padding-top: 20px;
  cursor: pointer;
}
.train-praise img {
  width: 15px;
  height: 15px;
}
.train-comment {
  width: 40px;
  height: 55px;
  float: left;
  padding-top: 20px;
  cursor: pointer;
}
.train-comment img {
  width: 15px;
  height: 15px;
}
.left-content {
  padding: 10px 0;
  width: 100%;
  min-height: 500px;
  height: auto;
  border-bottom: 1px solid #ccc;
}
.left-content img {
  width: 100%;
  height: 500px;
  margin-bottom: 20px;
}
.content-detail {
  margin: 10px 0px;
  color: #333;
}
.content-share {
  width: 100%;
  height: 40px;
}
.content-share .read {
  float: left;
  width: 120px;
  height: 40px;
  line-height: 40px;
}
.wechat {
  float: right;
  width: 100px;
  height: 40px;
  line-height: 40px;
}
.wechat img {
  height: 15px;
  width: 15px;
  margin: 0 5px;
}
.comment {
  height: auto;
}
.comment-input {
  min-height: 170px;
  width: 100%;
  background: #fff;
  border-bottom: 1px solid #ccc;
  padding-top: 20px;
}
.comment-input::after {
  content: "";
  clear: both;
  display: block;
  height: 0;
  overflow: hidden;
  visibility: hidden;
}
.comment-ava {
  width: 60px;
  height: 65px;
  float: left;
}
.comment-ava img {
  width: 60px;
  height: 65px;
  border-radius: 50%;
}
.comment-right {
  float: left;
  margin-left: 10px;
  width: 730px;
  min-height: 140px;
  background: #fff;
}
.person {
  margin-bottom: 20px;
}
.comment-me {
  float: right;
  margin-top: 10px;
}
.comment-author {
  float: left;
  margin-bottom: 20px;
}
.comment-info {
  height: auto;
  width: 730px;
  margin-left: 10px;
  float: left;
}
.comment-list ul li {
  height: auto;
  width: 100%;
  padding-top: 10px;
  border-bottom: 1px solid #ccc;
}
.comment-all-reply ul li {
  border-bottom: 0;
}
.comment-time {
  float: left;
  width: 190px;
  height: 35px;
  margin-top: 20px;
  color: #999;
}
.comment-right-con {
  float: right;
}
.comment-list ul ::after {
  content: "";
  clear: both;
  display: block;
  height: 0;
  overflow: hidden;
  visibility: hidden;
}
.comment-info-con {
  margin-top: 10px;
}
.com-reply {
  float: left;
  width: 550px;
  height: 100px;
  margin-left: 10px;
}
.color-666 {
  color: #666;
}
.color-999 {
  color: #999;
}
.com-cont {
  margin-top: 5px;
  margin-bottom: 10px;
}
.com-good {
  width: 100px;
  height: 100px;
  float: right;
  padding-top: 60px;
  cursor: pointer;
  padding-left: 45px;
}
.com-good img {
  width: 15px;
  height: 15px;
}
.zan {
  cursor: pointer;
}
.comment-ava {
  width: 60px;
  height: 65px;
  float: left;
}
.comment-ava img {
  width: 60px;
  height: 65px;
  border-radius: 50%;
}
.comment-right {
  float: left;
  margin-left: 10px;
  width: 730px;
  min-height: 140px;
  background: #fff;
}
</style>
